/***
*
*   SIGN UP (user)
*   Signup form for child users
*
**********/

import React, { useContext } from 'react';
import { Animate, Row, AuthContext, Card, Form } from 'components/lib';
import ReactGA from 'react-ga';
import Cookies from 'universal-cookie';

export function SignupUser(props){

  ReactGA.initialize('UA-51078254-5');
  ReactGA.pageview(window.location.pathname + window.location.search);

  let search = window.location.search;
  let params = new URLSearchParams(search);
  let ref = params.get('ref');

  const cookies = new Cookies();
  if(ref)
  {
    cookies.set('referral_code', ref, { path: '/' });  
  }

  const context = useContext(AuthContext);
  const url = window.location.href;
  const id = url.substring(url.indexOf('?id=')+4, url.indexOf('&email'));
  const email = url.substring(url.indexOf('&email')+7);

  return(
    <Animate type='pop'>
      <Row title='Create Your Account'>
        <Card restrictWidth center>
          <Form
            data={{
              name: {
                label: 'Full Name',
                value: '',
                type: 'text',
                required: true,
                errorMessage: 'Please enter your full name'
              },
              email: {
                label: 'Email',
                value: email,
                type: 'email',
                required: true,
              },
              password: {
                label: 'Password',
                type: 'password',
                required: true,
                complexPassword: true,
              },
              confirm_password: {
                type: 'hidden',
                value: null,
              },
              inviteId: {
                type: 'hidden',
                value: id
              },
            }}
            url='/api/user'
            method='POST'
            redirect='/dashboard'
            buttonText='Create Account'
            callback={ context.signin }
          />

          <span>Already registered? <a href='/signin'>Sign In</a></span>

        </Card>
      </Row>
    </Animate>
  );
}
